import React from 'react';
import { useParams } from 'react-router-dom';
import { XIcon } from '@phosphor-icons/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateUser } from 'api/users';
import { useFeedback } from 'contexts/feedback';
import TextInput from 'components/Form/TextInput';
import Button from 'components/Button';

export default function UserEditPopup({
    visible,
    setVisible,
    user
}) {

    const { userId } = useParams();
    const cache = useQueryClient();
    const { setSuccess, setError } = useFeedback();

    const { mutate: update } = useMutation({
        mutationKey: ['updateUser'],
        mutationFn: updateUser,
        onSuccess: () => {
            cache.invalidateQueries(['users']);
            setSuccess("Utente aggiornato con successo");
            return setVisible(false);
        },
        onError: (error) => {
            setError("Errore durante l'aggiornamento dell'utente");
            console.error("Error updating user:", error);
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();

        const formData = {  
            firstname: e.target.firstname.value || user?.firstname,
            lastname: e.target.lastname.value || user?.lastname,
            email: e.target.email.value || user?.email,
        }
        
        return update({
            id: userId,
            data: formData
        });
    }

    return (
        <div className={`fixed top-0 left-0 w-full h-full bg-white/90 bg-opacity-50 z-[var(--z-modal)] transition-all duration-300 ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
            <div className='bg-white rounded-sm border border-light w-full max-w-lg mx-4 md:mx-auto mt-40 p-6'>
                <div className='flex justify-between items-center pb-4'>
                    <p className='text-lg font-semibold'>{`Aggiungi utente all'area`}</p>
                    <div onClick={() => setVisible(false)} className='cursor-pointer text-muted hover:text-black'>
                        <XIcon size={20} />
                    </div>
                </div>

                <form onSubmit={onSubmitHandler} className='flex flex-col gap-4'>
                    <TextInput
                        label="Nome"
                        name="firstname"
                        placeholder="Nome"
                        defaultValue={user?.firstname}
                        required
                    />
                    <TextInput
                        label="Cognome"
                        name="lastname"
                        placeholder="Cognome"
                        defaultValue={user?.lastname}
                        required
                    />
                    <TextInput
                        label="Email"
                        name="email"
                        type="email"
                        placeholder="Email"
                        defaultValue={user?.email}
                        required
                    />

                    <div className='flex justify-between gap-4 mt-6'>
                        <div onClick={() => setVisible(false)} className='text-muted hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                            Annulla
                        </div>
                        <Button submit>Conferma</Button>
                    </div>
                </form>
            </div>
        </div>
    )
}
